/* eslint-disable no-restricted-syntax */
/**
 * This function finds the term from provided path
*/
const findTermFromPath = (termList, pathName) => {
  for (const term of termList) {
    if (pathName.includes(term.link)) {
      return term;
    }
    if (term.childNodes) {
      const filteredTerm = findTermFromPath(term.childNodes, pathName);
      if (filteredTerm) {
        return filteredTerm;
      }
    }
  }
  return undefined;
};

export default findTermFromPath;
